<template>
  <div class="checklist">
    <div v-if="isMiniElement"><i class="far fa-check-square"></i> {{ elCompletedCount }}<span style="margin: 0 1px">/</span>{{ elChecklist.length }}</div>
    <template v-else>
      <div v-for="item in elChecklistFiltered" :class="el.getChecklistItemClass(item)" :title="checklistItemTitle(item)">
        <i :class="item.checked ? 'fa-check-square' : 'fa-square'" class="far mr-1"
           @click.stop="$emit('checklist-click', item)">
        </i>
        <span>{{ item.title }}</span>
      </div>
    </template>
  </div>
</template>

<style lang="scss">
  .v-theme--dark {
    .checklist {
      .text-errorred, .text-warningorange {
        & .fa-square + span {
          background: rgb(var(--v-theme-surface));
          border-radius: 12px;
          padding: 0px 4px;
        }
      }
    }
  }
</style>

<script>
  import { workloadToDisplay } from '@/components/Workload/workloadHelpers';
  import useUsersStore from '@/stores/users';

  const momentMediumDateNoYearFormat = moment.localeData().custom && moment.localeData().custom('mediumDateNoYear') || 'MMM D';

  export default {
    props: {
      el: { type: Object, required: true },
      elChecklistFiltered: { type: Array, required: true },
      isMiniElement: { type: Boolean, default: false },
    },
    emits: ['checklist-click'],
    computed: {
      elChecklist() {
        return this.el.getChecklist() || [];
      },
      elCompletedCount() {
        return this.elChecklist.filter(item => item.checked).length;
      },
    },
    methods: {
      checklistItemTitle(item) {
        let username = useUsersStore().getUsername({ id: item.user_id, username: item.username });
        username = username && `${username}\n`;
        const duedate = item.duedate && `${moment(item.duedate).format(momentMediumDateNoYearFormat)}\n`;
        const workload = (item.workload || item.workload_used)
          && `${this.$t('HR.WORKLOAD')} : ${workloadToDisplay(item.workload || 0)}⯈${workloadToDisplay(item.workload_used || 0)}`;
        return (username || '') + (duedate || '') + (workload || '');
      },
    },
  };
</script>
